interface listType {
	[key:string]: string[]
}
const l:listType =  {'2024':[
"VidT-2024-001.jpg",
"VidT-2024-002.jpg",
"VidT-2024-003.jpg",
"VidT-2024-004.jpg",
"VidT-2024-005.jpg",
"VidT-2024-006.jpg",
"VidT-2024-007.jpg",
"VidT-2024-008.jpg",
"VidT-2024-009.jpg",
"VidT-2024-010.jpg",
"VidT-2024-011.jpg",
"VidT-2024-012.jpg",
"VidT-2024-013.jpg",
"VidT-2024-014.jpg",
"VidT-2024-015.jpg",
"VidT-2024-016.jpg",
"VidT-2024-017.jpg",
"VidT-2024-018.jpg",
"VidT-2024-019.jpg",
"VidT-2024-020.jpg",
"VidT-2024-021.jpg",
"VidT-2024-022.jpg",
"VidT-2024-023.jpg",
"VidT-2024-024.jpg",
"VidT-2024-025.jpg",
"VidT-2024-026.jpg",
"VidT-2024-027.jpg",
"VidT-2024-028.jpg",
"VidT-2024-029.jpg",
"VidT-2024-030.jpg",
"VidT-2024-031.jpg",
"VidT-2024-032.jpg",
"VidT-2024-033.jpg",
"VidT-2024-034.jpg",
"VidT-2024-035.jpg",
"VidT-2024-036.jpg",
"VidT-2024-037.jpg",
"VidT-2024-038.jpg",
"VidT-2024-039.jpg",
"VidT-2024-040.jpg",
"VidT-2024-041.jpg",
"VidT-2024-042.jpg",
"VidT-2024-043.jpg",
"VidT-2024-044.jpg",
"VidT-2024-045.jpg",
"VidT-2024-046.jpg",
"VidT-2024-047.jpg",
"VidT-2024-048.jpg",
"VidT-2024-049.jpg",
"VidT-2024-050.jpg",
"VidT-2024-051.jpg",
"VidT-2024-052.jpg",
"VidT-2024-053.jpg",
"VidT-2024-054.jpg",
"VidT-2024-055.jpg",
"VidT-2024-056.jpg",
"VidT-2024-057.jpg",
"VidT-2024-058.jpg",
"VidT-2024-059.jpg",
"VidT-2024-060.jpg",
"VidT-2024-061.jpg",
"VidT-2024-062.jpg",
"VidT-2024-063.jpg",
"VidT-2024-064.jpg",
"VidT-2024-065.jpg",
"VidT-2024-066.jpg",
"VidT-2024-067.jpg",
"VidT-2024-068.jpg",
"VidT-2024-069.jpg",
"VidT-2024-070.jpg",
"VidT-2024-071.jpg",
"VidT-2024-072.jpg",
"VidT-2024-073.jpg",
"VidT-2024-074.jpg",
"VidT-2024-075.jpg",
"VidT-2024-076.jpg",
"VidT-2024-077.jpg",
"VidT-2024-078.jpg",
"VidT-2024-079.jpg",
"VidT-2024-080.jpg",
"VidT-2024-081.jpg",
"VidT-2024-082.jpg",
"VidT-2024-083.jpg",
"VidT-2024-084.jpg",
"VidT-2024-085.jpg",
"VidT-2024-086.jpg",
"VidT-2024-087.jpg",
"VidT-2024-088.jpg",
"VidT-2024-089.jpg",
"VidT-2024-090.jpg",
"VidT-2024-091.jpg",
"VidT-2024-092.jpg",
"VidT-2024-093.jpg",
"VidT-2024-094.jpg",
"VidT-2024-095.jpg",
"VidT-2024-096.jpg",
"VidT-2024-097.jpg",
"VidT-2024-098.jpg",
"VidT-2024-099.jpg",
"VidT-2024-100.jpg",
"VidT-2024-101.jpg",
"VidT-2024-102.jpg",
"VidT-2024-103.jpg",
"VidT-2024-104.jpg",
"VidT-2024-105.jpg",
"VidT-2024-106.jpg",
"VidT-2024-107.jpg",
"VidT-2024-108.jpg",
"VidT-2024-109.jpg",
"VidT-2024-110.jpg",
"VidT-2024-111.jpg",
"VidT-2024-112.jpg",
"VidT-2024-113.jpg",
"VidT-2024-114.jpg",
"VidT-2024-115.jpg",
"VidT-2024-116.jpg",
"VidT-2024-117.jpg",
"VidT-2024-118.jpg",
"VidT-2024-119.jpg",
"VidT-2024-120.jpg",
"VidT-2024-121.jpg",
"VidT-2024-122.jpg",
"VidT-2024-123.jpg",
"VidT-2024-124.jpg",
"VidT-2024-125.jpg",
"VidT-2024-126.jpg",
"VidT-2024-127.jpg",
"VidT-2024-128.jpg",
"VidT-2024-129.jpg",
"VidT-2024-130.jpg",
"VidT-2024-131.jpg",
"VidT-2024-132.jpg",
"VidT-2024-133.jpg",
"VidT-2024-134.jpg",
"VidT-2024-135.jpg",
"VidT-2024-136.jpg",
"VidT-2024-137.jpg",
"VidT-2024-138.jpg",
"VidT-2024-139.jpg",
"VidT-2024-140.jpg",
"VidT-2024-141.jpg",
"VidT-2024-142.jpg",
"VidT-2024-143.jpg",
"VidT-2024-144.jpg",
"VidT-2024-145.jpg",
"VidT-2024-146.jpg",
"VidT-2024-147.jpg",
"VidT-2024-148.jpg",
"VidT-2024-149.jpg",
"VidT-2024-150.jpg",
"VidT-2024-151.jpg",
"VidT-2024-152.jpg",
"VidT-2024-153.jpg",
"VidT-2024-154.jpg",
"VidT-2024-155.jpg",
"VidT-2024-156.jpg",
"VidT-2024-157.jpg",
"VidT-2024-158.jpg",
"VidT-2024-159.jpg",
"VidT-2024-160.jpg",
"VidT-2024-161.jpg",
"VidT-2024-162.jpg",
"VidT-2024-163.jpg",
"VidT-2024-164.jpg",
"VidT-2024-165.jpg",
"VidT-2024-166.jpg",
"VidT-2024-167.jpg",
"VidT-2024-168.jpg",
"VidT-2024-169.jpg",
"VidT-2024-170.jpg",
"VidT-2024-171.jpg",
"VidT-2024-172.jpg",
"VidT-2024-173.jpg",
"VidT-2024-174.jpg",
"VidT-2024-175.jpg",
"VidT-2024-176.jpg",],

'2025': [
	"20250513 - Vrouwen in de Top - 001.jpg",
"20250513 - Vrouwen in de Top - 002.jpg",
"20250513 - Vrouwen in de Top - 003.jpg",
"20250513 - Vrouwen in de Top - 006.jpg",
"20250513 - Vrouwen in de Top - 007.jpg",
"20250513 - Vrouwen in de Top - 008.jpg",
"20250513 - Vrouwen in de Top - 009.jpg",
"20250513 - Vrouwen in de Top - 010.jpg",
"20250513 - Vrouwen in de Top - 011.jpg",
"20250513 - Vrouwen in de Top - 012.jpg",
"20250513 - Vrouwen in de Top - 013.jpg",
"20250513 - Vrouwen in de Top - 014.jpg",
"20250513 - Vrouwen in de Top - 015.jpg",
"20250513 - Vrouwen in de Top - 016.jpg",
"20250513 - Vrouwen in de Top - 017.jpg",
"20250513 - Vrouwen in de Top - 018.jpg",
"20250513 - Vrouwen in de Top - 019.jpg",
"20250513 - Vrouwen in de Top - 020.jpg",
"20250513 - Vrouwen in de Top - 021.jpg",
"20250513 - Vrouwen in de Top - 022.jpg",
"20250513 - Vrouwen in de Top - 023.jpg",
"20250513 - Vrouwen in de Top - 024.jpg",
"20250513 - Vrouwen in de Top - 025.jpg",
"20250513 - Vrouwen in de Top - 027.jpg",
"20250513 - Vrouwen in de Top - 028.jpg",
"20250513 - Vrouwen in de Top - 029.jpg",
"20250513 - Vrouwen in de Top - 030.jpg",
"20250513 - Vrouwen in de Top - 031.jpg",
"20250513 - Vrouwen in de Top - 032.jpg",
"20250513 - Vrouwen in de Top - 033.jpg",
"20250513 - Vrouwen in de Top - 034.jpg",
"20250513 - Vrouwen in de Top - 035.jpg",
"20250513 - Vrouwen in de Top - 036.jpg",
"20250513 - Vrouwen in de Top - 037.jpg",
"20250513 - Vrouwen in de Top - 038.jpg",
"20250513 - Vrouwen in de Top - 039.jpg",
"20250513 - Vrouwen in de Top - 040.jpg",
"20250513 - Vrouwen in de Top - 042.jpg",
"20250513 - Vrouwen in de Top - 043.jpg",
"20250513 - Vrouwen in de Top - 044.jpg",
"20250513 - Vrouwen in de Top - 045.jpg",
"20250513 - Vrouwen in de Top - 046.jpg",
"20250513 - Vrouwen in de Top - 047.jpg",
"20250513 - Vrouwen in de Top - 048.jpg",
"20250513 - Vrouwen in de Top - 049.jpg",
"20250513 - Vrouwen in de Top - 050.jpg",
"20250513 - Vrouwen in de Top - 051.jpg",
"20250513 - Vrouwen in de Top - 052.jpg",
"20250513 - Vrouwen in de Top - 053.jpg",
"20250513 - Vrouwen in de Top - 054.jpg",
"20250513 - Vrouwen in de Top - 055.jpg",
"20250513 - Vrouwen in de Top - 056.jpg",
"20250513 - Vrouwen in de Top - 057.jpg",
"20250513 - Vrouwen in de Top - 058.jpg",
"20250513 - Vrouwen in de Top - 059.jpg",
"20250513 - Vrouwen in de Top - 060.jpg",
"20250513 - Vrouwen in de Top - 061.jpg",
"20250513 - Vrouwen in de Top - 062.jpg",
"20250513 - Vrouwen in de Top - 063.jpg",
"20250513 - Vrouwen in de Top - 064.jpg",
"20250513 - Vrouwen in de Top - 065.jpg",
"20250513 - Vrouwen in de Top - 066.jpg",
"20250513 - Vrouwen in de Top - 068.jpg",
"20250513 - Vrouwen in de Top - 069.jpg",
"20250513 - Vrouwen in de Top - 070.jpg",
"20250513 - Vrouwen in de Top - 071.jpg",
"20250513 - Vrouwen in de Top - 072.jpg",
"20250513 - Vrouwen in de Top - 073.jpg",
"20250513 - Vrouwen in de Top - 074.jpg",
"20250513 - Vrouwen in de Top - 075.jpg",
"20250513 - Vrouwen in de Top - 076.jpg",
"20250513 - Vrouwen in de Top - 077.jpg",
"20250513 - Vrouwen in de Top - 078.jpg",
"20250513 - Vrouwen in de Top - 080.jpg",
"20250513 - Vrouwen in de Top - 081.jpg",
"20250513 - Vrouwen in de Top - 082.jpg",
"20250513 - Vrouwen in de Top - 083.jpg",
"20250513 - Vrouwen in de Top - 084.jpg",
"20250513 - Vrouwen in de Top - 086.jpg",
"20250513 - Vrouwen in de Top - 089.jpg",
"20250513 - Vrouwen in de Top - 090.jpg",
"20250513 - Vrouwen in de Top - 091.jpg",
"20250513 - Vrouwen in de Top - 092.jpg",
"20250513 - Vrouwen in de Top - 093.jpg",
"20250513 - Vrouwen in de Top - 094.jpg",
"20250513 - Vrouwen in de Top - 095.jpg",
"20250513 - Vrouwen in de Top - 096.jpg",
"20250513 - Vrouwen in de Top - 097.jpg",
"20250513 - Vrouwen in de Top - 098.jpg",
"20250513 - Vrouwen in de Top - 099.jpg",
"20250513 - Vrouwen in de Top - 100.jpg",
"20250513 - Vrouwen in de Top - 101.jpg",
"20250513 - Vrouwen in de Top - 102.jpg",
"20250513 - Vrouwen in de Top 2025 - 001 - Verbeterd.jpg",
"20250513 - Vrouwen in de Top 2025 - 025.jpg",
"20250513 - Vrouwen in de Top 2025 - 026.jpg",
"20250513 - Vrouwen in de Top 2025 - 027.jpg",
"20250513 - Vrouwen in de Top 2025 - 028.jpg",
"20250513 - Vrouwen in de Top 2025 - 029.jpg",
"20250513 - Vrouwen in de Top 2025 - 030.jpg",
"20250513 - Vrouwen in de Top 2025 - 031.jpg",
"20250513 - Vrouwen in de Top 2025 - 032.jpg",
"20250513 - Vrouwen in de Top 2025 - 034.jpg",
"20250513 - Vrouwen in de Top 2025 - 035.jpg",
"20250513 - Vrouwen in de Top 2025 - 036.jpg",
"20250513 - Vrouwen in de Top 2025 - 037.jpg",
"20250513 - Vrouwen in de Top 2025 - 038.jpg",
"20250513 - Vrouwen in de Top 2025 - 039.jpg",
"20250513 - Vrouwen in de Top 2025 - 040.jpg",
"20250513 - Vrouwen in de Top 2025 - 042.jpg",
"20250513 - Vrouwen in de Top 2025 - 044.jpg",
"20250513 - Vrouwen in de Top 2025 - 045.jpg",
"20250513 - Vrouwen in de Top 2025 - 046.jpg",
"20250513 - Vrouwen in de Top 2025 - 047.jpg",
"20250513 - Vrouwen in de Top 2025 - 048.jpg",
"20250513 - Vrouwen in de Top 2025 - 049.jpg",
"20250513 - Vrouwen in de Top 2025 - 050.jpg",
"20250513 - Vrouwen in de Top 2025 - 051.jpg",
"20250513 - Vrouwen in de Top 2025 - 052.jpg",
"20250513 - Vrouwen in de Top 2025 - 053.jpg",
"20250513 - Vrouwen in de Top 2025 - 054.jpg",
"20250513 - Vrouwen in de Top 2025 - 055.jpg",
"20250513 - Vrouwen in de Top 2025 - 056.jpg",
"20250513 - Vrouwen in de Top 2025 - 057.jpg",
"20250513 - Vrouwen in de Top 2025 - 058.jpg",
"20250513 - Vrouwen in de Top 2025 - 059.jpg",
"20250513 - Vrouwen in de Top 2025 - 060.jpg",
"20250513 - Vrouwen in de Top 2025 - 061.jpg",
"20250513 - Vrouwen in de Top 2025 - 062.jpg",
"20250513 - Vrouwen in de Top 2025 - 063.jpg",
"20250513 - Vrouwen in de Top 2025 - 064.jpg",
"20250513 - Vrouwen in de Top 2025 - 065.jpg",
"20250513 - Vrouwen in de Top 2025 - 066.jpg",
"20250513 - Vrouwen in de Top 2025 - 067.jpg",
"20250513 - Vrouwen in de Top 2025 - 068.jpg",
"20250513 - Vrouwen in de Top 2025 - 069.jpg",
"20250513 - Vrouwen in de Top 2025 - 070.jpg",
"20250513 - Vrouwen in de Top 2025 - 071.jpg",
"20250513 - Vrouwen in de Top 2025 - 072.jpg",
"20250513 - Vrouwen in de Top 2025 - 073.jpg",
"20250513 - Vrouwen in de Top 2025 - 074.jpg",
"20250513 - Vrouwen in de Top 2025 - 075.jpg",
"20250513 - Vrouwen in de Top 2025 - 076.jpg",
"20250513 - Vrouwen in de Top 2025 - 077.jpg",
"20250513 - Vrouwen in de Top 2025 - 078.jpg",
"20250513 - Vrouwen in de Top 2025 - 079.jpg",
"20250513 - Vrouwen in de Top 2025 - 080.jpg",
"20250513 - Vrouwen in de Top 2025 - 081.jpg",
"20250513 - Vrouwen in de Top 2025 - 082.jpg",
"20250513 - Vrouwen in de Top 2025 - 083.jpg",
"20250513 - Vrouwen in de Top 2025 - 084.jpg",
"20250513 - Vrouwen in de Top 2025 - 085.jpg",
"20250513 - Vrouwen in de Top 2025 - 086.jpg",
"20250513 - Vrouwen in de Top 2025 - 087.jpg",
"20250513 - Vrouwen in de Top 2025 - 088.jpg",
"20250513 - Vrouwen in de Top 2025 - 089.jpg",
"20250513 - Vrouwen in de Top 2025 - 090.jpg",
"20250513 - Vrouwen in de Top 2025 - 091.jpg",
"20250513 - Vrouwen in de Top 2025 - 092.jpg",
"20250513 - Vrouwen in de Top 2025 - 093.jpg",
"20250513 - Vrouwen in de Top 2025 - 094.jpg",
"20250513 - Vrouwen in de Top 2025 - 095.jpg",
"20250513 - Vrouwen in de Top 2025 - 096.jpg",
"20250513 - Vrouwen in de Top 2025 - 097.jpg",
"20250513 - Vrouwen in de Top 2025 - 098.jpg",
"20250513 - Vrouwen in de Top 2025 - 099.jpg",
"20250513 - Vrouwen in de Top 2025 - 100.jpg",
"20250513 - Vrouwen in de Top 2025 - 101.jpg",
"20250513 - Vrouwen in de Top 2025 - 102.jpg",
"20250513 - Vrouwen in de Top 2025 - 103.jpg",
"20250513 - Vrouwen in de Top 2025 - 104.jpg",
"20250513 - Vrouwen in de Top 2025 - 105.jpg",
"20250513 - Vrouwen in de Top 2025 - 106.jpg",
"20250513 - Vrouwen in de Top 2025 - 107.jpg",
"20250513 - Vrouwen in de Top 2025 - 108.jpg",
"20250513 - Vrouwen in de Top 2025 - 109.jpg",
"20250513 - Vrouwen in de Top 2025 - 110.jpg",
"20250513 - Vrouwen in de Top 2025 - 111.jpg",
"20250513 - Vrouwen in de Top 2025 - 112.jpg",
"20250513 - Vrouwen in de Top 2025 - 113.jpg",
"20250513 - Vrouwen in de Top 2025 - 114.jpg",
"20250513 - Vrouwen in de Top 2025 - 115.jpg",
"20250513 - Vrouwen in de Top 2025 - 116.jpg",
]
}
export default l